export const ApiWorkers = {
    get: (params) => ({
        url: "/user-candidates",
        method: "GET",
        params,
    }),
    getById: (id) => ({
        url: `/user-candidates/${id}`,
        method: "GET",
    }),
    getAdditional: (data) => ({
        url: `/additionalCandidateDetails`,
        method: "POST",
        data,
    }),
    getCandidatesByJob: (id) => ({
        url: `/getCandidatesByJob?job_id=${id}`,
        method: "GET",
    }),
    getActiveCandidatesByJob: (id) => ({
        url: `/getActiveCandidatesByJob?job_id=${id}`,
        method: "GET",
    }),
    delete: (id) => ({
        url: "/deleteCandidate",
        method: "PUT",
        data: {
            user_candidate_id: id,
        },
    }),
    update: (data) => ({
        url: `/updateCandidateById`,
        method: "PUT",
        data,
    }),
    settlementCandidates: (data) => ({
        url: "/settlementCandidates",
        method: "POST",
        data,
    }),
};
